{
  "search": "Rechercher",
  "searchWithin": "Rechercher dans"
}
